import { createFileRoute } from '@tanstack/react-router';
import { CashierShiftsTable } from '@mews-commander/cashiers';
import { ArticlePath, createGuideLink, FeatureFlag, TextKey } from '@mews-commander/enums';
import { GuideLinkButton, PageLayout, useBreadcrumbs } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Cashier/')({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.cashierShiftPagesMigration);
    },
    component: () => <PageComponent />,
    staticData: {
        title: TextKey.CashierPlural,
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
    },
});

const PageComponent = () => {
    const breadcrumbs = useBreadcrumbs();

    const actions = <GuideLinkButton guideLink={createGuideLink(ArticlePath.CreateDeleteCashier)} />;

    return (
        <PageLayout padded actions={actions} breadcrumbs={breadcrumbs}>
            <CashierShiftsTable />
        </PageLayout>
    );
};
